<template>
  <div class="news">
    <ComponentHeader v-bind:index="index" />

    <div id="image" class="image">
      <div>LAST INFORMATION</div>
      <div>最新资讯</div>
    </div>

    <section v-if="this.total">
      <el-row class="bt">
        <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="bt_main"
          >最新资讯</el-col
        >
      </el-row>
      <el-row class="news">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="news_block">
          <el-col
            :xs="20"
            :sm="20"
            :md="20"
            :lg="20"
            :xl="20"
            v-for="(item, index) of news"
            :key="index"
          >
            <div class="new">
              <div class="head" @click="lookNew(item.GG_ID)">
                <div>{{ item.GG_BT }}</div>
                <div>{{ item.GG_CJSJ }}</div>
              </div>
              <ul></ul>
            </div>
          </el-col>
        </el-col>

        <el-pagination
          v-if="total !== 0"
          ref="page"
          id="page"
          layout="prev, pager, next"
          :total="total"
          :page-size="4"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-row>
      <el-row class="blank"></el-row>
    </section>
    <div class="blank"></div>
    <ComponentFooter />
  </div>
</template>


<script>
import "../ui/ui.js";
import { axios } from "../service/http";
import moment from "moment";
import ComponentFooter from "../components/Footer.vue";
import ComponentHeader from "../components/Header.vue";

export default {
  components: { ComponentFooter, ComponentHeader },
  name: "Home",
  data() {
    return {
      index: "3",
      news: [{ GG_BT: "" }, { GG_BT: "" }, { GG_BT: "" }, { GG_BT: "" }],
      total: 100,
      q: {
        ps: 4,
        pi: 1,
        txt: "",
        zt: "Y",
      },
      isLeave: false,
    };
  },
  methods: {
    lookNew(i) {
      this.$router.push(`/new/${i}`);
    },
    getNews() {
      axios.get("TZGG", { params: this.q }).then((res) => {
        res.response.data.forEach((item) => {
          item.GG_CJSJ = moment(item.GG_CJSJ).format("YYYY-MM-DD");
        });
        this.news = res.response.data;
        this.total = res.response.total;
      });
    },
    handleCurrentChange(i) {
      this.q.pi = i;
      this.getNews();
    },
    changePageColor() {
      document.querySelectorAll("#page>button")[0].style.background = "#92c5c2";
      document.querySelectorAll("#page>button")[1].style.background = "#92c5c2";
      let page = document.querySelectorAll("#page>ul>li.number");
      page.forEach((ele) => {
        ele.style.background = "#92c5c2";
      });
    },
  },
  mounted() {
    this.getNews();
    this.changePageColor();
  },
};
</script>

<style lang="less" scoped>
.news {
  .el-row {
    margin: 0 !important;
  }
  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div {
      color: #d2f9e9;
      font-weight: 400;
      &:first-child {
        font-size: 0.18rem;
      }
      &:last-child {
        font-size: 0.15rem;
      }
    }
  }
  section {
    .bt {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      .bt_main {
        font-size: 0.15rem;
        font-weight: bold;
        margin: 22px 0 20px;
      }
    }
    .news {
      height: 2.5rem;
      background: url("../assets/image/news_bg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      position: relative;
      .bt ();
      .news_block {
        display: flex;
        justify-content: center;
        flex-direction: column;
        .el-col {
          margin: 0 auto;
          font-size: 26px;
          margin-bottom: 10px;
          div.new {
            color: #000;
            width: 100%;
            opacity: 0.6;
            border-radius: 0.1rem;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            font-size: 0.08rem;
            color: #000;
            font-weight: bold;
            .head {
              text-align: left;
              height: 100%;
              display: flex;
              justify-content: space-between;
              div {
                &:first-child {
                  width: 70%;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                }
                &:last-child {
                  width: 25%;
                  text-align: right;
                }
              }
            }
            ul {
              width: 100%;
              border-bottom: 1px dashed #707070;
            }
            .new_btn {
              display: block;
              text-align: center;
              margin-bottom: 20px;
              button {
                width: 0.8rem;
                height: 0.18rem;
                background: #f9f0ff;
                border-radius: 0.15rem;
                background: #f9f0ff;
                outline: 0;
                border: 0;
              }
            }
          }
        }
      }
      #page {
        display: flex;
        justify-content: center;
        height: 50px;
        width: 90%;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>